<template>
  <div :class="$style.box" @touchmove.prevent>
    <div :class="$style.content">
      <img :class="$style.bg" :src="`${$cdnUrl}/imperialGlory/dialog-bg.png`" alt="" />
      <img
        :class="$style.btn"
        :src="`${$cdnUrl}/imperialGlory/dialog-join.png`"
        @click="jump"
        alt=""
      />
      <img
        :class="$style.close"
        :src="`${$cdnUrl}/imperialGlory/dialog-mid-close.png`"
        @click="close"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const date = new Date();
    localStorage.setItem('sign-in-date', date);
  },
  methods: {
    jump() {
      this.$router.push({ name: 'activity.imperialGlory' });
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 300;

  .content {
    width: 100%;
    min-height: 200px;
    margin: 100px auto;

    .bg {
      width: 100%;
    }

    .btn {
      width: 135px;
      display: block;
      margin: -20px auto 0px auto;
    }

    .close {
      width: 25px;
      display: block;
      margin: 20px auto;
    }
  }
}
</style>